'use client';

export const socialMediaList = [
  {
    id: 'whatsapp',
    image: '/icons/whatsapp.svg',
    link: process.env.NEXT_PUBLIC_WHATSAPP_LINK,
  },
  {
    id: 'messenger',
    image: '/icons/messenger.svg',
    link: process.env.NEXT_PUBLIC_MESSENGER_LINK,
  },
  {
    id: 'facebook',
    image: '/icons/facebook.svg',
    link: process.env.NEXT_PUBLIC_FACEBOOK_LINK,
  },
  {
    id: 'instagram',
    image: '/icons/instagram.svg',
    link: process.env.NEXT_PUBLIC_INSTAGRAM_LINK,
  },
  {
    id: 'linkedin',
    image: '/icons/linkedin.svg',
    link: process.env.NEXT_PUBLIC_LINKEDIN_LINK,
  },
];

export const otherSocialMediaList = [];
